import { create } from 'zustand';

interface VendorLoginDialogState {
    isOpen: boolean;
}

interface VendorLoginDialogAction {
    setIsOpen: (isOpen: boolean) => void;
}

export const useVendorLoginDialogStore = create<VendorLoginDialogState & VendorLoginDialogAction>((set) => ({
    isOpen: false,
    setIsOpen: (isOpen) => set({ isOpen }),
}));
